var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my_wallet_private"}},[_c('h1',[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.wallet.privateKey))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e29f1ef2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/details/MyWalletPrivate.vue
// module id = 656
// module chunks = 1